import { Reducer } from "redux";
import { TPermissionAction } from "../actions/permissionActions";
import { TLoadable, createUnloaded, createLoaded } from "../../../../sg-core";
import { ICategoryPermission } from "../../interfaces/ICategoryPermission";

export interface IPermissionsState {
    categoryPermissions: TLoadable<ICategoryPermission[]>;
}

export const defaultCategoryPermissionState: IPermissionsState = {
    categoryPermissions: createUnloaded(),
};

const permissionsReducer: Reducer<IPermissionsState, TPermissionAction> = (state = defaultCategoryPermissionState, action): IPermissionsState => {

    const setCategoryPermissions = (value: IPermissionsState["categoryPermissions"]): IPermissionsState => ({
        ...state,
        categoryPermissions: value,
    });

    switch (action.type) {
        case "SUCCESS_CATEGORY_PERMISSIONS": {
            return setCategoryPermissions(createLoaded(action.payload.permissions));
        }
    }

    return state!;
};

export default permissionsReducer;
